/**
 * Formats a duration in seconds to a human-readable string.
 * @param totalSeconds - The duration in seconds.
 * @returns A string representing the duration in minutes and seconds.
 */
export const formatDuration = (totalSeconds: number): string => {
  const roundedTotalSeconds = Math.round(totalSeconds);

  if (roundedTotalSeconds < 60) {
    return `${roundedTotalSeconds}s`;
  }

  const minutes = Math.floor(roundedTotalSeconds / 60);
  const seconds = roundedTotalSeconds % 60;

  return `${minutes}m ${seconds}s`;
};
